/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from 'styled-components';
import theme from './ResetPasswordPage.theme';

export const ResetPasswordPage = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  margin-top: 3rem;

  .footerBtns {
    margin-top: 2.813rem;
    text-align: right;
  }

  .cancel-button {
    color: ${props => theme(props).cancelButtonColor};
  }
`;

export const Container = styled('div')`
  background: ${props => theme(props).background};
  padding: 1rem;
  width: 38.75rem;
`;

export const Title = styled('h1')`
  color: ${props => theme(props).color};
  font-size: 1.29rem;
  margin-bottom: 2.6875rem;
  margin-top: 2.625rem;
`;
